import { render, staticRenderFns } from "./indexProfile.vue?vue&type=template&id=206e0e94&"
import script from "./indexProfile.vue?vue&type=script&lang=ts&"
export * from "./indexProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports